import { createAction, props } from '@ngrx/store';
import { TodoEntryModel } from '../../models/todo-planner/todo-entry.model';

/* Fetch */
export const fetchSingleTodoPlannerEntry = createAction(
  '[Todo Planner] Fetch Single TodoPlannerEntry',
  props<{ payload: number }>(),
);

export const setSingleTodoPlannerEntry = createAction(
  '[Todo Planner] Set Single TodoPlannerEntry',
  props<{ payload: TodoEntryModel }>(),
);

export const fetchTodoPlannerEntries = createAction(
  '[Todo Planner] Fetch TodoPlannerEntries',
  props<{ payload: { start; end; userId } }>(),
);

export const setTodoPlannerEntries = createAction(
  '[Todo Planner] Set TodoPlannerEntries',
  props<{ payload: TodoEntryModel[] }>(),
);

/* Add */
export const addTodoPlannerEntry = createAction(
  '[Todo Planner] Add TodoPlannerEntry',
  props<{ payload: TodoEntryModel }>(),
);

export const todoPlannerEntryAdded = createAction(
  '[Todo Planner] Added TodoPlannerEntry',
  props<{ payload: { todoEntryModel: TodoEntryModel } }>(),
);

/* Update */
export const updateTodoPlannerEntry = createAction(
  '[Todo Planner] Update TodoPlannerEntry',
  props<{ payload: { todoEntryModel: TodoEntryModel } }>(),
);

export const todoPlannerEntryUpdated = createAction(
  '[Todo Planner] Updated TodoPlannerEntry',
  props<{ payload: { todoEntryModel: TodoEntryModel } }>(),
);

/* Update Multiple */
export const updateMultipleTodoPlannerEntries = createAction(
  '[Todo Planner] Update TodoPlannerEntries',
  props<{ payload: { todoEntryModels: TodoEntryModel[] } }>(),
);

export const todoPlannerMultipleEntriesUpdated = createAction(
  '[Todo Planner] Updated TodoPlannerEntries',
  props<{ payload: { todoEntryModels: TodoEntryModel[] } }>(),
);

/* Delete */
export const deleteTodoPlannerEntry = createAction(
  '[Todo Planner] Delete TodoPlannerEntry',
  props<{ payload: TodoEntryModel }>(),
);

export const todoPlannerEntryDeleted = createAction(
  '[Todo Planner] Deleted TodoPlannerEntry',
  props<{ payload: { todoEntryModel: TodoEntryModel } }>(),
);

/* Error */
export const httpFail = createAction('[Todo Planner] Http fail', props<{ payload: string }>());
